module.exports = __webpack_public_path__ + "2123d7ea44474b6ac722e25595f44368.svg";